<template>
  <el-progress type="circle" :percentage="$store.getters['publicProgress/getPublicProgress']"
               v-show="$store.getters['publicProgress/getShowProgress']"
  ></el-progress>
</template>

<script>
export default {
  name: 'MyProgress'
}
</script>

<style scoped>

.el-progress {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
